export function isLoggedIn() {
  return !!localStorage.getItem("@etableToken");
}
